module.exports = __webpack_public_path__ + "img/2x.ba6150b.jpg";